<template>
  <layout mode="solid">
    <el-main v-loading="loading">
      <breadCrumb :list="breadCrumbData"></breadCrumb>
      <div class="product-largetop">
        <div class="container">
          <el-row :gutter="10">
            <el-col :md="13" :lg="13" :xl="13" class="images-box">
              <el-carousel trigger="click" :autoplay="false" indicator-position="none">
                <el-carousel-item v-for="item in image" :key="item.id">
                  <viewer :images="model.image">
                    <img :src="item.url" />
                  </viewer>
                </el-carousel-item>
              </el-carousel>
              <viewer :images="model.image" class="imagesbox-inner">
                <img v-for="item in image" :key="item.id" :src="item.url" />
              </viewer>
            </el-col>
            <el-col :md="11" :lg="11" :xl="11">
              <div class="product-profilebox">
                <div class="product-info">
                  <h2>{{ model.document_title }}</h2>
                  <p>{{ model.document_profile }}</p>
                </div>
                <div class="product-btn">
                  <el-button @click="openBuyLink" round>{{
                    $lang.com("ButIt")
                  }}</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="product-detail container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$lang.com('ProductDes')" name="first">
            <viewer :trigger="content">
              <div v-html="content"></div>
            </viewer>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
  </layout>
</template>

<script>
import { documentDetailByKeywords } from "@/api/document.js";
export default {
  data() {
    return {
      loading: false,
      activeName: "first",
      keywords: 0,
      content: "",
      model: {
        image: [],
      },
      breadCrumbData: [],
      image: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    let keywords = to.params.keywords;
    next((vm) => {
      vm.init(keywords);
    });
  },
  components: {
    layout: (resolve) => require(["../shared/layout"], resolve),
    breadCrumb: (resolve) => require(["@/components/breadcrumb.vue"], resolve),
  },
  methods: {
    async init(keywords) {
      let vm = this;
      this.loading = true;
      let resp = await documentDetailByKeywords(keywords);
      this.content = resp.data.document_content;
      vm.model = resp.data;
      vm.image = resp.data.image;

      let category = vm.$tools.category.getById(
        vm.model.document_category,
        (node) => {
          return {
            text: node.category_name,
            path: `/product/${node.category_keywords}`,
          };
        }
      );
      vm.breadCrumbData.push({ text: this.$lang.com("home"), path: "/" });
      vm.breadCrumbData.push(category);
      vm.breadCrumbData.push({
        text: this.$lang.com("productDetail"),
        isActive: true,
      });
      this.loading = false;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.content = "";
    },
    openBuyLink() {
      window.open(this.model.document_url);
    },
  },
};
</script>